import React from 'react';
import TableTimerCard from '../pages/TableTimecard';
import '../styles/TableTracker.css';

const tables = [
  { label: 'S1', rate: 300 },
  { label: 'S2', rate: 240 },
  { label: 'S3', rate: 240 },
  { label: 'M1', rate: 200 },
  { label: 'M2', rate: 200 },
  { label: 'M3', rate: 200 },
  { label: 'PS4-1', rate: 100 },
  { label: 'PS4-2', rate: 100 },
];

const TableTracker = () => {
  return (
    <div className="tracker-container">
      <h2>Snooker Table Tracker</h2>
      <div className="grid">
        {tables.map(({ label, rate }) => (
          <TableTimerCard key={label} label={label} hourlyRate={rate} />
        ))}
      </div>
    </div>
  );
};

export default TableTracker;
